import { jsx as _jsx } from "react/jsx-runtime";
import { createIconSetFromFontello } from '@expo/vector-icons';
import { useFonts } from 'expo-font';
const icons = require('./config.json');
const Icon = createIconSetFromFontello(icons, 'tipicons', 'tipicons.ttf');
const iconNames = icons.glyphs.map((x) => x.css);
export function isValidIcon(name) {
    return iconNames.includes(name || '');
}
export function IconView({ name, size = 16, color, style }) {
    const [fontsLoaded] = useFonts({
        tipicons: require('./font/tipicons.ttf')
    });
    if (!fontsLoaded) {
        return null;
    }
    return _jsx(Icon, { name: name, size: size, color: color, style: style });
}
